export const projectTypesData = [
  {
    title_en: "Road",
    title_ne: "सडक",
    value: "road",
  },
  {
    title_en: "Bridge",
    title_ne: "पुल",
    value: "bridge",
  },
  {
    title_en: "Embankment",
    title_ne: "नदि तटबन्ध",
    value: "embankment",
  },
  {
    title_en: "Drinking Water Project",
    title_ne: "खानेपानी आयोजना",
    value: "drinking_water_project",
  },
  {
    title_en: "Canals/Drainages",
    title_ne: "कुलो/नाला",
    value: "canals/drainages",
  },
  { title_en: "Wall", title_ne: "पर्खाल", value: "wall" },
  {
    title_en: "Educational Institution",
    title_ne: "शैक्षिक संस्था",
    value: "educational_institution",
  },
  {
    title_en: "Health Institution",
    title_ne: "स्वास्थ्य संस्था",
    value: "health_institution",
  },
  {
    title_en: "Temple/Mosque/Church/Madrasa",
    title_ne: "मन्दिर/मस्जिद/चर्च/मदरसा",
    value: "temple/mosque/church/madrasa",
  },
  {
    title_en: "Community Building",
    title_ne: "सामुदायिक भवन",
    value: "community_building",
  },
  {
    title_en: "Cold Storage",
    title_ne: "चिस्यान केन्द्र",
    value: "cold_storage",
  },
  {
    title_en: "Business Center",
    title_ne: "व्यवसायिक केन्द्र",
    value: "business_center",
  },
  { title_en: "Bus Park", title_ne: "बसपार्क", value: "bus_park" },
  {
    title_en: "Tourism Infrastructure",
    title_ne: "पर्यटकीय पूर्वाधार",
    value: "tourism_infrastructure",
  },
  {
    title_en: "Others",
    title_ne: "अन्य",
    value: "others",
  },
];

export const projectRoadType = [
  {
    value: "black_top_road",
    text_en: "Black top road",
    text_ne: "कालोपत्रे सडक",
  },
  { value: "gravel_road", text_en: "Gravel road", text_ne: "ग्राभेल सडक" },
  {
    value: "path/horse_trail",
    text_en: "Path/Horse Trail",
    text_ne: "गोरेटो/घोडेटो",
  },
  {
    value: "tourist_trail",
    text_en: "Tourist trail",
    text_ne: "पर्यटक पदमार्ग",
  },
  { value: "others", text_en: "Others", text_ne: "अन्य" },
];

export const implementationModal = [
  { value: "user_group", text_en: "User Group", text_ne: "उपभोक्ता समिति" },
  { value: "tender", text_en: "Tender", text_ne: "टेण्डर" },
  { value: "quotation", text_en: "Quotation", text_ne: "कोटेशन" },
  { value: "others", text_en: "Others", text_ne: "अन्य" },
];

export const projectStats = [
  { value: "", text_en: "All", text_ne: "सबै" },
  { value: "submitted", text_en: "Submitted", text_ne: "पेश गरिएको" },
  { value: "evaluated", text_en: "Evaluated", text_ne: "मूल्यांकन गरिएको" },
];



// WEBPACK FOOTER //
// ./src/config/localProjects.js